'use strict';

angular.module('shiftTraderApp')
  .service('ActivityIndicatorService', ['uuid4', function (uuid4) {

    var transactions = {};

    var beginTransaction = function(keyword, data) {
      var uuid = uuid4.generate();
      transactions[uuid] = {
        startTime: moment.utc(),
        keyword: keyword,
        data: data
      };
      //console.groupCollapsed('ActivityManager');
      //console.log('New Transaction');
      //console.log('UUID: ' + uuid);
      //console.log(transactions[uuid]);
      //console.groupEnd();
      return uuid;
    };

    var endTransaction = function(uuid) {
      //console.groupCollapsed('ActivityManager');
      //console.log('Ending Transaction');
      if (_.isUndefined(transactions[uuid])) {
        //console.groupEnd();
        return false;
      } else {
        //console.log('UUID: ' + uuid);
        //console.log(transactions[uuid]);
        //console.log('Transaction Length: ', transactions[uuid].startTime.twix(moment.utc()).length('milliseconds'));
        delete transactions[uuid];
        //console.groupEnd();
        return true;
      }
    };

    var isActivityInProgress = function() {
      return _.size(transactions) > 0;
    };

    return {
      beginTransaction: beginTransaction,
      endTransaction: endTransaction,
      isActivityInProgress: isActivityInProgress
    };

  }]);
